import React from 'react';

import { useAtomValue } from 'jotai';

import {
  accountAtom,
  accountIdAtom,
  alertBannerAtom,
  appVariantAtom,
  authMethodAtom,
  incomeDataAtom,
  iovationBlackboxAtom,
  isApplyVariantAtom,
  isCaliforniaAddressAtom,
  isEmailApplyEligibleAtom,
  isIncomeDetailsRequiredAtom,
  isReturningCustomerFlowAtom,
  isWisconsinAddressAtom,
  modalConfigAtom,
  registrationDataAtom,
  sendCodeCountdownSecondsAtom,
} from '@consumer-frontend/nc-components';

export const DevToolsAtomSubscriber: React.FC = () => {
  useAtomValue(accountAtom);
  useAtomValue(accountIdAtom);
  useAtomValue(alertBannerAtom);
  useAtomValue(appVariantAtom);
  useAtomValue(authMethodAtom);
  useAtomValue(incomeDataAtom);
  useAtomValue(iovationBlackboxAtom);
  useAtomValue(isApplyVariantAtom);
  useAtomValue(isCaliforniaAddressAtom);
  useAtomValue(isEmailApplyEligibleAtom);
  useAtomValue(isReturningCustomerFlowAtom);
  useAtomValue(isWisconsinAddressAtom);
  useAtomValue(modalConfigAtom);
  useAtomValue(registrationDataAtom);
  useAtomValue(sendCodeCountdownSecondsAtom);
  useAtomValue(isIncomeDetailsRequiredAtom);

  return null;
};
